var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6037",
    "data-name": "Path 6037",
    d: "M9.294,15.1a2.5,2.5,0,0,0,3.537,0l2.676-2.676a.833.833,0,0,0-1.178-1.176L11.89,13.689,11.9.833A.833.833,0,0,0,11.062,0h0a.833.833,0,0,0-.833.833l-.007,12.84L7.8,11.25a.834.834,0,1,0-1.178,1.179Z",
    transform: "translate(-1.062 0)",
    fill: "#bbc6d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6038",
    "data-name": "Path 6038",
    d: "M19.167,16h0a.833.833,0,0,0-.833.833v3.333A.833.833,0,0,1,17.5,21H2.5a.833.833,0,0,1-.833-.833V16.833A.833.833,0,0,0,.833,16h0A.833.833,0,0,0,0,16.833v3.333a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5V16.833A.833.833,0,0,0,19.167,16Z",
    transform: "translate(0 -2.667)",
    fill: "#bbc6d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrDownload);
export default __webpack_public_path__ + "static/media/fi-rr-download.6ee876c6.svg";
export { ForwardRef as ReactComponent };